import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import {
  resetSelectedProduct,
  setSelectedProduct,
} from '../data/returnInvoices/actions';
import { selectReturnInvoicesProductFamily } from '../data/returnInvoices/selectors';
import { productFamilyThemeClass } from '../constants/productFamily';

export const useReturnInvoicesProductFamily = () => {
  const selectedProduct = useSelector(selectReturnInvoicesProductFamily);
  const dispatch = useDispatch();
  const setProduct = useCallback(
    productId => {
      dispatch(setSelectedProduct(productId));
    },
    [dispatch]
  );
  return [selectedProduct, setProduct];
};

export const useResetReturnInvoicesProductFamilyOnExit = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetSelectedProduct());
    };
  }, [dispatch]);
};

export const useReturnInvoicesProductFamilyTheme = () => {
  const selectedProduct = useSelector(selectReturnInvoicesProductFamily);
  return productFamilyThemeClass(selectedProduct);
};
